import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import { ListUsersService } from './services';

@NgModule({ imports: [StoreModule], providers: [ListUsersService] })
export class EngagementApiUtilsModule {}
